<template lang="pug">
  div.ml-3
    input#massUpload(
      :key="key"
      type="file"
      ref="inputFile"
      name="file"
      @change="importData"
      class="sr-only"
    )
    label(for="massUpload" class="mb-0")
      b-button(variant="status-approved" size="sm" tag="div") Adjuntar carga masiva
</template>
<script>
import readXlsxFile from 'read-excel-file'
export default {
  props: ['communesOptions'],
  data () {
    return {
      key: 0,
      packages: [],
      tagsNames: {
        FLEX: 'flex',
        CAMBIO: 'exchange',
        DEVOLUCIÓN: 'return'
      },
      schema: {
        TIENDA: {
          prop: 'storeName',
          type: String,
          required: true
        },
        'NOMBRE DEL DESTINATARIO': {
          prop: 'customerName',
          type: String
        },
        'TELÉFONO DEL DESTINATARIO': {
          prop: 'customerPhone',
          type: String,
          required: true
        },
        'DIRECCIÓN DE DESTINO': {
          prop: 'customerAddress',
          type: String,
          required: true
        },
        'COMUNA DE DESTINO': {
          prop: 'customerCommune',
          type: String,
          required: true
        },
        OBSERVACIONES: {
          prop: 'observations',
          type: String
        },
        CORREO: {
          prop: 'customerEmail',
          type: String
        },
        'TAMAÑO DEL PAQUETE': {
          prop: 'size',
          type: String
        },
        'CANTIDAD DE BULTOS': {
          prop: 'bundleQuantity',
          type: String
        },
        TAGS: {
          prop: 'tags',
          type: String
        },
        'ID EXTERNO': {
          prop: 'externalId',
          type: String
        }
      }
    }
  },
  methods: {
    openFileDialog () {
      this.$refs.inputFile.click()
    },
    getCommune (name) {
      const result = this.communesOptions.filter(commune => this.normalizeText(commune.text) === this.normalizeText(name))
      return result.length > 0 ? result[0].value : null
    },
    normalizeText (text) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return text.toLowerCase()
    },
    cleanPhone (phone) {
      // quitar espacios, signos de mas y caracteres no numericos y se queda con los ultimos 9 digitos
      let phoneClean = phone.replace(/[^0-9]/g, '').replace(' ', '').replace('+', '')
      phoneClean = phoneClean.slice(-9)
      return phoneClean
    },
    importData (e) {
      this.$emit('loading', true)
      try {
        readXlsxFile(e.target.files[0], { schema: this.schema, sheet: 1 })
          .then(({ rows, errors }) => {
            rows.forEach(row => {
              const pack = {
                withdrawalId: null,
                customerName: row.customerName !== undefined ? row.customerName : '',
                customerPhone: row.customerPhone !== undefined ? this.cleanPhone(row.customerPhone) : '',
                customerAddress: row.customerAddress !== undefined ? row.customerAddress : '',
                customerEmail: row.customerEmail !== undefined ? row.customerEmail : '',
                commune: row.customerCommune !== undefined ? this.getCommune(row.customerCommune) : null,
                bundleQuantity: row.bundleQuantity !== undefined ? parseInt(row.bundleQuantity) || 1 : 1,
                size: row.size === 'PEQUEÑO' ? 'small' : (row.size === 'MEDIANO' ? 'medium' : null),
                tags: row.tags ? this.tagsNames[row.tags.toUpperCase()] : null,
                shippingCost: 0,
                observations: row.observations !== undefined ? row.observations : '',
                externalId: row.externalId !== undefined ? row.externalId : null
              }
              if (pack.customerName === '' && pack.customerPhone === '' && pack.customerAddress === '') {
                row++
              } else {
                this.packages.push(pack)
              }
            })
            this.$emit('done', JSON.parse(JSON.stringify(this.packages)))
            this.packages = []
          })
      } catch (err) {
        console.log(err)
      }
      this.key++
      this.$emit('loading', false)
    }
  }
}
</script>
